/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */

/*
download data block
*/

import * as Blockly from 'blockly/core';
import 'blockly/python';
import { firebaseConfig } from '../../firebase.js';

Blockly.Blocks['output_download'] = {
    init: function () {
        console.log("download init storage bucket:" + firebaseConfig.storageBucket);
        let downloadNameValidator = newValue => {
            let maxLength = 20;
            let cleanValue = newValue.replace(/[^a-zA-Z0-9_ ]/g, "");
            let trimmedValue = cleanValue.substring(0, maxLength)
            return trimmedValue;
        }

        this.appendDummyInput()
            .appendField('Download: ', 'downtext')
            .appendField(new Blockly.FieldTextInput('file_name', downloadNameValidator),
                'filename')
            .appendField(new Blockly.FieldDropdown([[".tif", "tif"]]), 'fileformat') //, [".png", "png"]

        this.appendDummyInput('GeotiffLabel')
            .appendField('Geotiff format options') ;
        this.appendDummyInput("COG")
            .appendField("    COG Format")
            .appendField(new Blockly.FieldCheckbox(false), 'cloudOptimised')
        this.appendDummyInput("geotiff_options")
            .appendField("    Skip blanks")
            .appendField(new Blockly.FieldCheckbox(true), 'skipBlanks')

        this.getField("filename").setTooltip(Blockly.Msg.FILE_NAME_TOOLTIP)
        this.setTooltip(Blockly.Msg.DOWNLOAD_BLOCK_TOOLTIP);
        this.setHelpUrl("");
        this.setPreviousStatement(true, 'download');
        this.setStyle('download');
    }
};